/*
 * @Description:
 * @Autor: yd
 * @Date: 2020-07-02 11:21:57
 * @LastEditors: yd
 * @LastEditTime: 2020-07-22 09:43:07
 */
//定时任务
import http from '../httpConfig'

const table = 'mrbase_sys_params_setting'
    //获取所有系统参数
export const getSystemParameterList = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http.post('/api/systemParameter/getAll/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

//获取系统参数详情
export const detailSystemParameter = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http.post('/api/systemParameter/getInfo/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

//新增系统参数
export const addSystemParameter = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http.post('/api/systemParameter/add/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

//修改系统参数
export const updateSystemParameter = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http.post('/api/systemParameter/update/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

//删除系统参数
export const deleteSystemParameter = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http.post('/api/systemParameter/delete/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}